export const menuLinks = [
  {
    label: 'Home',
    to: 'https://superlogica.com/'
  },
  {
    label: 'Software',
    to: '#',
    dropdown: [
      {
        icon: 'circle-condominios',
        label: 'Superlógica Condomínios',
        headline:
          'Sistema de gestão mais utilizado por administradoras de condomínios',
        to: 'https://superlogica.com/condominios/',
        color: 'aqua700'
      },
      {
        icon: 'circle-imobiliarias',
        label: 'Superlógica Imobiliárias',
        headline: 'Locação e vendas',
        to: 'https://superlogica.com/imobiliarias/',
        color: 'red700'
      },
      {
        icon: 'circle-assinaturas',
        label: 'Superlógica Assinaturas',
        headline: 'SaaS e mensalidades',
        to: 'https://superlogica.com/assinaturas/',
        color: 'orange500'
      }
    ]
  },
  {
    label: 'Serviços Financeiros',
    to: '#',
    dropdown: [
      {
        label: 'Receber com boleto',
        to: 'https://superlogica.com/condominios/servicos-financeiros/boleto/'
      },
      {
        label: 'Receber com cartão de crédito',
        to: 'https://superlogica.com/condominios/servicos-financeiros/cartao/'
      },
      {
        label: 'Parcelamento no cartão de crédito',
        to:
          'https://superlogica.com/condominios/servicos-financeiros/parcelamento/'
      },
      {
        label: 'Inadimplência Zero',
        to:
          'https://superlogica.com/condominios/servicos-financeiros/inadimplencia/'
      }
    ]
  },
  {
    label: 'Eventos',
    to: '#',
    dropdown: [
      {
        icon: 'circle-xperience',
        label: 'Superlógica Xperience',
        to: 'https://xperience.superlogica.com/'
      },
      {
        icon: 'circle-next',
        label: 'Superlógica Next',
        to: 'https://next.superlogica.com/'
      }
    ]
  },
  {
    label: 'Blog',
    to: 'https://blog.superlogica.com/'
  }
]
